/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CommentReactionRequest model module.
 * @module model/CommentReactionRequest
 * @version V1
 */
class CommentReactionRequest {
    /**
     * Constructs a new <code>CommentReactionRequest</code>.
     * @alias module:model/CommentReactionRequest
     */
    constructor() { 
        
        CommentReactionRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CommentReactionRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CommentReactionRequest} obj Optional instance to populate.
     * @return {module:model/CommentReactionRequest} The populated <code>CommentReactionRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CommentReactionRequest();

            if (data.hasOwnProperty('commentId')) {
                obj['commentId'] = ApiClient.convertToType(data['commentId'], 'Number');
            }
            if (data.hasOwnProperty('reactionType')) {
                obj['reactionType'] = ApiClient.convertToType(data['reactionType'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CommentReactionRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CommentReactionRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['reactionType'] && !(typeof data['reactionType'] === 'string' || data['reactionType'] instanceof String)) {
            throw new Error("Expected the field `reactionType` to be a primitive type in the JSON string but got " + data['reactionType']);
        }

        return true;
    }


}



/**
 * @member {Number} commentId
 */
CommentReactionRequest.prototype['commentId'] = undefined;

/**
 * @member {String} reactionType
 */
CommentReactionRequest.prototype['reactionType'] = undefined;






export default CommentReactionRequest;

